module.exports = __webpack_public_path__ + "img/banner.2472657d.png";